(function () {
    'use strict';

    function navigate(el, openInNewTab) {
        const href = el.dataset.href;
        if (!href) return;

        const target = el.dataset.target;
        if (openInNewTab || target === '_blank') {
            window.open(href, '_blank', el.dataset.rel || 'noopener');
        } else {
            window.location.href = href;
        }
    }

    document.addEventListener('click', function (event) {
        const el = event.target.closest('.mm-obfuscated-link');
        if (!el) return;
        event.preventDefault();
        navigate(el, event.ctrlKey || event.metaKey || event.button === 1);
    });

    document.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        const el = event.target.closest('.mm-obfuscated-link');
        if (!el) return;
        event.preventDefault();
        navigate(el, false);
    });
})();
